// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/global"], () => (__webpack_require__("./src/js/global.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/global"], () => (__webpack_require__("./src/scss/global/_index.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
